import React from 'react';
import {useSelector} from 'react-redux';

import {applicationsSelector, selectedApplicationSelector, errorFlagSelector} from 'modules/applications/selectors';

import Title from 'components/Text/Title';
import Loading from 'components/Controls/Loading';
import Icon from 'components/Notifications/Icon';
import AppCards from './AppCards';

export default function Home() {

    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1000,
        marginTop: 50,
    };

    const apps = useSelector(applicationsSelector);
    const selectedApp = useSelector(selectedApplicationSelector);
    const errorFlag = useSelector(errorFlagSelector);

    const rowSize = 4;
    const rows = 2;

    let content;

    if (errorFlag) {
        content = <div style={containerStyles}>
            <Title>Error</Title>
            <p>There has been a temporary error accessing your applications. Please try again later.</p>
        </div>
    } else if (selectedApp) {
        content = <div style={containerStyles}><Loading text={'Loading ' + selectedApp.name + '...'} /></div>;
    } else if (apps === null) {
        content = <div style={containerStyles}><Loading text="Loading applications..."/></div>;
    } else if (apps.length == 0) {
        containerStyles.width = 500;

        const subtitleStyles = {
            fontWeight: 'bold',
            display: 'flex'
        };

        content = <div style={containerStyles}>
            <Title>API-Only Account</Title>
            <p style={subtitleStyles}><Icon type="success" size={10} />Your account is active and configured for API service access.</p>
            <p>As your account is intended for API integration only, there is nothing to view here and no further action is required.</p>
            <p>Please continue to follow the onboarding information and documentation provided for your integration.</p>
            <p>If you believe you should have access to a browser-based application, please contact your Client Delivery Manager or Distribution Account Manager.
            </p>
        </div>
    } else {
        content = <article style={containerStyles}>
            <Title>Welcome</Title>
            <p>Select an app from the items below or from the dropdown menu.</p>
            <AppCards apps={apps} rowSize={rowSize} rows={rows}/>
        </article>;
    }

    return content;
}